<template>
  <div class="order-details">
    <div class="order-info">
      <div class="form-block">
        <div class="form-title">
          <div class="form-icon"></div>
          <div class="flex">套餐信息</div>
        </div>
        <div class="form-content">
          <div class="form-cell">
            <div class="form-label">应用名称：</div>
            <div class="form-value ">{{setMealInfo.appName}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">套餐名称：</div>
            <div class="form-value ">{{setMealInfo.packageName}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">标准时长：</div>
            <div class="form-value ">
              {{setMealInfo.packagePeriodNum}}{{['','天','个月'][setMealInfo.packagePeriodUnit]}}
            </div>
          </div>
          <div class="form-cell">
            <div class="form-label">标准费用：</div>
            <div class="form-value ">{{setMealInfo.packagePrice|moneyToYuan}}元</div>
          </div>
        </div>
      </div>
      <div class="form-block">
        <div class="form-title">
          <div class="form-icon"></div>
          <div class="flex">订单信息</div>
        </div>
        <div class="form-content">
          <div class="form-cell">
            <div class="form-label">订单号：</div>
            <div class="form-value ">{{orderInfo.orderNo}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">订单状态：</div>
            <div class="form-value ">{{orderState}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">创建时间：</div>
            <div class="form-value ">{{orderInfo.creationTime}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">支付时间：</div>
            <div class="form-value ">{{orderInfo.payTime||''}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">订单类型：</div>
            <div class="form-value ">{{OrderTypeLabel[setMealInfo.type]}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">购买时长：</div>
            <div class="form-value ">
              {{(setMealInfo.packagePeriodNum||0)*(setMealInfo.buyNum||0)}}{{['','天','个月'][setMealInfo.packagePeriodUnit]}}
            </div>
          </div>
          <div class="form-cell">
            <div class="form-label">付款金额：</div>
            <div class="form-value ">{{orderInfo.payMoney|moneyToYuan}}元</div>
          </div>
          <div class="form-cell">
            <div class="form-label">结算状态：</div>
            <div class="form-value ">{{OrderCloseStateLabel[orderInfo.closeState]}}</div>
          </div>
          <div class="form-cell" v-if="orderInfo.payState>0">
            <span class="form-label">有效期:</span>
            <span class="form-value">{{termTime }}</span>
          </div>
        </div>
      </div>
      <div class="form-block">
        <div class="form-title">
          <div class="form-icon"></div>
          <div class="flex">客户信息</div>
        </div>
        <div class="form-content">
          <div class="form-cell">
            <div class="form-label">用户姓名：</div>
            <div class="form-value ">{{ buyUserInfo.realName}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">企业名称：</div>
            <div class="form-value ">{{buyUserInfo.compName}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">联系电话：</div>
            <div class="form-value ">{{ buyUserInfo.phone}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">联系邮箱：</div>
            <div class="form-value ">{{ buyUserInfo.email||''}}</div>
          </div>
        </div>
      </div>
    </div>
    <refund-info :orderNo="orderNo" v-if="orderInfo.payState>0"/>

  </div>
</template>

<script>
  import OrderService from "../../apis/orderService";
  import {
    OrderCloseStateLabel,
    OrderStateLabel,
    OrderTypeLabel,
    RefundReasonStateLabel,
    RefundStateLabel
  } from "../../service/enum";
  import {dateFormat} from "../../utils/util";
  import RefundInfo from "./refund-info";

  export default {
    name: "order-details",
    components: {RefundInfo},
    data() {
      return {
        orderNo: "",
        orderInfo: {},
        OrderStateLabel,
        OrderTypeLabel,
        OrderCloseStateLabel,
        RefundStateLabel,
        RefundReasonStateLabel

      }
    },
    computed: {
      termTime() {
        return this.setMealInfo.endTime ? `${ dateFormat(this.setMealInfo.beginTime, 'yyyy/MM/dd')}- ${dateFormat(this.setMealInfo.endTime, 'yyyy/MM/dd')}` : '';
      },
      orderState() {
        return OrderService.getOrderStateLabel(this.orderInfo.orderState, this.orderInfo.payState)
      },
      setMealInfo() {
        return this.orderInfo.details ? this.orderInfo.details[0] : {}
      },
      buyUserInfo() {
        return this.orderInfo.buyUserInfo || {};
      }
    },
    methods: {
      async getInfo() {
        const res = await OrderService.getOrderInfo(this.orderNo);
        this.orderInfo = res;
      },

    },
    mounted() {
      this.orderNo = this.$route.query.orderNo;
      this.getInfo();
    },
    filters: {
      moneyToYuan(money) {
        if (money === 0) return "0.00";
        if (!money) return "";
        return OrderService.toYuan(money);
      }
    }
  }
</script>

<style scoped lang="scss">
  .order-details {
    min-width: 1550px;
    .order-info {
      display: inline-block;
      width: 800px;
      vertical-align: top;
    }
    ::v-deep  .form-block {
      margin-bottom: 35px;
      .form-title {
        height: 32px;
        line-height: 32px;
        display: flex;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        .form-icon {
          width: 4px;
          background-color: #1B9AEE;
          margin-right: 20px;
        }
      }
      .form-content {
        margin-top: 30px;
        display: flex;
        flex-wrap: wrap;
        .form-cell {
          display: flex;
          width: 300px;
          font-size: 14px;
          color: #333;
          margin-bottom: 35px;

          &:nth-of-type(even) {
            min-width: 55%;
            margin-left: 60px;
          }
          .form-label {
            color: #666;
            min-width: 80px;
          }
        }
      }
    }
  }
</style>
